import { Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useShareList } from 'src/hooks/useShareList';
import messagesActions from 'src/store/actions/message';
import { handleAddInternetSources, handleAddSources } from 'src/store/actions/sources';
import { BotMessage, Message } from 'src/types';
import { useAppDispatch, useAppSelector } from 'universal-scripts';
import Chat from '../Chat/Chat';
import Loading from '../Loading/Loading';

const ShareChat = () => {
	const { id: chatId } = useParams<{ id: string }>();
	const { messages } = useShareList(chatId as string);
	const [blocked, setBlocked] = useState(true);
	const [isInitializing, setIsInitializing] = useState(true);
	const storeMessages = useAppSelector((s) => s.messages);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!storeMessages.length && messages?.length) {
			for (const m of messages as Message[]) {
				dispatch(messagesActions.addMessage(m));
			}

			for (const message of messages) {
				if (message.from === 'bot') {
					const botMsg = message as BotMessage;
					if (botMsg.sources?.length) {
						dispatch(handleAddSources(botMsg.id, botMsg.sources));
					}
					if (botMsg.internetSources?.length) {
						dispatch(handleAddInternetSources(botMsg.id, botMsg.internetSources));
					}
				}
			}

			setIsInitializing(false);
		}
	}, [messages, dispatch, storeMessages.length]);

	if (isInitializing && !storeMessages.length) {
		return (
			<div id="chat">
				<Loading />
			</div>
		);
	}

	return <Chat blocked={blocked} handleBlocked={setBlocked} />;
};

const ShareChatWrapper = () => {
	return (
		<Suspense fallback={<Loading />}>
			<ShareChat />
		</Suspense>
	);
};

export default ShareChatWrapper;
